import ListAssistances from '@/pages/Assistant/ListAssistances.vue';
import ShowAssistance from '@/pages/Assistant/ShowAssistance.vue';
import context from '@/router/guards/context';
export default [
    {
        path: '/assistances',
        name: 'assistances.list',
        component: ListAssistances,
        beforeEnter: [context],
    },
    {
        path: 'assistances/:id',
        name: 'assistances.show',
        component: ShowAssistance,
        beforeEnter: [context],
        props: true,
    },
];
